import './uploader.css';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';

const boot = window.LIMU_BOOT;

if (!boot) {
  console.error('LIMU_BOOT config missing — Limitless Uploader not initialised');
} else {
  const el = document.getElementById('limu-uploader');
  if (el) {
    createRoot(el).render(<App boot={boot} />);
  }
}
